const TransactionFragment = `
    id
    chainData
`

export default TransactionFragment
